module.exports = __webpack_public_path__ + "static/media/kh.7f27fa73.svg";